import {getColorByPath, getThemeValue, ThemeColorPath, ThemeRadiusPath} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {useComponentsTheme} from '../../hooks/useComponentsTheme';
import {PERCENT_SCALE} from './utils/resolveLevel';

interface LevelFillProps {
  $fraction: number;
  $bandColor: ThemeColorPath;
  $radius: ThemeRadiusPath;
}

const levelFillVariants = cva('absolute bottom-0 left-0 top-0');

export function LevelFill(props: LevelFillProps) {
  const theme = useComponentsTheme();

  return (
    <div
      className={cn(levelFillVariants())}
      style={{
        width: `${props.$fraction * PERCENT_SCALE}%`,
        borderRadius: getThemeValue<string>(theme.radii, props.$radius),
        backgroundColor: getColorByPath(props.$bandColor, theme),
      }}
    />
  );
}
